import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobileAndroidAlt } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'reactstrap';
import { QRCode } from 'react-qrcode-logo';

//Context
import { useAuth } from '../../../context/auth';

//API
import setup_api from '../../../api/setup_api';

//Helpers
import { showMessage } from "../../../helpers/message"

function DownloadAplicativos() {
  //Referencia ao link do app
  const refLink = useRef();

  //Estado que guarda o link do aplicativo para download
  const [linkApp, setLinkApp] = useState("");

  const { setLoading } = useAuth();

  //Pega o link do download do app assim que a tela é carregada
  useEffect(() => {
    setLoading(true);
    setup_api.GetLinkApp().then(response => {
      setLinkApp(response.data);
    })
    .catch(e => showMessage("Aviso", e.message, "error", null))
    .finally(f => setLoading(false));
  }, []);

  return <>
    <div className=' d-flex align-items-center justify-content-center bg-light p-4 m-4 rounded-3 shadow'>
      <a href={linkApp} ref={refLink} target={"_blank"}></a>
      <div className='d-flex align-items-center justify-content-center flex-column'>
        <h4 className='fw-light'><span className="fw-bold">Aplicativo</span></h4>
        <p>Escaneie o QrCode ou clique no botão abaixo para realizar o download do aplicativo</p>
        <div className="d-flex align-items-center flex-column justify-content-center">
          <div className="d-flex align-items-center justify-content-center shadow rounded-3">
            <QRCode
              value={linkApp}
              enableCORS={true}
              size="250"
              logoOpacity={1}
              qrStyle={"squares"}
              fgColor={"#000"}
              bgColor={"#fff"}
              logoWidth={60}
              logoheight={60}
            />
          </div>
          <Button
            onClick={() => refLink.current.click()}
            className={"mt-4"}
            color='success'
            contained>
            <FontAwesomeIcon icon={faMobileAndroidAlt} className=" me-3" />  Download do app
          </Button>
        </div>
      </div>
    </div>
  </>;
}

export default DownloadAplicativos;